import { Outlet } from "react-router-dom";
import "./Layout.scss";
import { useEffect, useState } from "react";
import {useDispatch} from "react-redux";
import {setAccount} from "reducer/account";
import useWhisperConnect from "modules/Whisper/useWhisperConnect";

function Layout(props: {}) {
  const dispatch = useDispatch();

  const [whisperConnectState, _] = useState({
    refreshToken: () => {},
    useAutoConnect: true,
  });

  const {
    isConnect,
    userInfo,
    isInWhisper,
    connectWhisper,
    disconnectWhisper,
  } = useWhisperConnect(whisperConnectState);

  useEffect(() => {
    // @ts-ignore
      dispatch(
      setAccount({
        isConnect,
        userInfo,
        isInWhisper,
      })
    );
  }, [
    dispatch,
    isConnect,
    userInfo,
    isInWhisper,
    connectWhisper,
    disconnectWhisper,
  ]);

  return (
    <main id={"layout"}>
      <Outlet
        context={{
          isConnect,
          userInfo,
          isInWhisper,
          connectWhisper,
          disconnectWhisper,
        }}
      />
    </main>
  );
}

export default Layout;
